import { render, staticRenderFns } from "./listing.vue?vue&type=template&id=00061018"
import script from "./listing.vue?vue&type=script&lang=js"
export * from "./listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00061018')) {
      api.createRecord('00061018', component.options)
    } else {
      api.reload('00061018', component.options)
    }
    module.hot.accept("./listing.vue?vue&type=template&id=00061018", function () {
      api.rerender('00061018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sectors/listing.vue"
export default component.exports